import { useMemo } from 'react';
import { MenuCartItem } from '../models/menu.types';
// combine attributes from recommendation items and cart items
export function useRecommendationsWithMenuCartItems(recommendations?: MenuCartItem [],
  menuWithCartItems?: MenuCartItem []): MenuCartItem[] {
  return useMemo(() => {
    if (!recommendations) return [];

    return recommendations.map((menuItem) => ({
      ...menuItem,
      isFavorite: menuWithCartItems?.find((item) => item.skuId === menuItem.skuId)?.isFavorite
        ?? false,
      quantity: menuWithCartItems?.find((cartItem) => cartItem.skuId === menuItem.skuId)?.quantity
        ?? 0,
    }));
  }, [menuWithCartItems, recommendations]);
}
